import React from "react";
import {Link} from 'react-router-dom'

import "../SideBar/SideBar.css"
import { withMyDataContext } from "../../context/DataProvider";
import Aux from "../AuxFunctions";
import Fire from "../../config/Fire";
import Loader from "../Utilities/Loader";

class TopHashtags extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showMore: false,
            originalTags: Aux.temporaryTags,
            tags: Aux.temporaryTags,
            isLoading: false,
            hashtagText: "",
            isSearching: false,
        }
    }

    componentDidMount = async() => {
        try {
            this.getTopTags();
        } catch (error) {
            Aux.handleError(error)
        }
    }


    getTopTags = async () => {
        if(this.state.isLoading)
        return
        try{
            this.setState({isLoading:true})
            await Fire.shared
                .GetPostsData("hashtags", null, 20)
                .then(snapshot => {
                    if (snapshot) {

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });

                        var n = data.length
                        var aux = 0
                        if(n < 20){
                            for (let index = n; index < 20; index++) {
                                data[index] = Aux.temporaryTags[aux]
                                aux ++;
                            }
                        }

                        this.setState({
                            tags: [...data],  originalTags: [...data]
                        });

                    }
                });
                this.setState({isLoading:false})
        }catch(error){
            this.setState({isLoading:false})
            Aux.handleError(error)
        }
    }


    hashtagRender = () => {
        return (
        <div style={{marginTop:30}} >
            <div className="cat-menu full-shadow" style={{marginLeft:10, marginBottom:20}}>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <span className="side-bar-title-text">Hashtag</span>
            </div>
            <div className="cat-underline"></div>
            <Link className={ !this.props.myDataProvider.currentHashtag ? "cat-single-item-menu cat-menu-active" :"cat-single-item-menu"} to={"/"} >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <span className="side-bar-main-text">#all</span>
                </div>
            </Link>
            {this.state.isLoading ? <div style={{display:"flex", justifyContent:"center", overflow:"hidden"}}><Loader style={{marginBottom:20}}/></div> : 
                this.state.tags.map((item, i) => (
                    <Link key={i} className={ this.props.myDataProvider.currentHashtag === item.hashtag ? "cat-single-item-menu cat-menu-active" :"cat-single-item-menu"} to={!item.hashtag? "/" : "/hashtag/" + item.hashtag} >
                        <span className="side-bar-main-text">#{item.hashtag}</span> 
                        {item.coins ? <span className="side-bar-coins-text">{item.coins}$</span> : null}

                    </Link>
                ))}
            </div>
        </div>
        );
    }

    render() {
        return (
            <div style={{display: "flex"}}>
                <this.hashtagRender></this.hashtagRender>
            </div>
        );
    };

    
}
export default withMyDataContext(TopHashtags);
